import * as forgeProviderActions from '../actions/forgeprovider.actions';
import { call, put, retry, select, takeLatest } from 'redux-saga/effects';
import { logoutRedirect } from '@innovyze/stylovyze/lib/utils/userEmulation';
import { getForgeLogoutRedirectUrl, retriedGetAutodeskContext, } from '../services/forge.service';
import removeAllAuthStorage from '@innovyze/stylovyze/lib/utils/removeAllAuthStorage';
import { userEndEmulation } from '../services';
import { userContextEmulationSelector } from '../selectors/userContext.selectors';
import { setTenantId } from '../storages/tenantId';
function* logoutSaga(action) {
    const { forgeLogoutRejected } = forgeProviderActions;
    try {
        console.info('logoutSaga isEmulationAllowed', JSON.stringify(action.payload, null, 2));
        const emulationEnabled = yield select(userContextEmulationSelector);
        if (emulationEnabled) {
            const emulationResponse = yield retry(3, 3000, userEndEmulation) || {};
            console.info('Emulation terminated with response:', JSON.stringify({
                data: emulationResponse?.data,
                status: emulationResponse?.status,
                statusText: emulationResponse?.statusText,
            }, null, 2));
            const autodeskUserContext = yield call(retriedGetAutodeskContext, null);
            yield call(setTenantId, autodeskUserContext.organizationId);
        }
        const logoutUrl = yield call(getForgeLogoutRedirectUrl, action.payload.config?.forge);
        yield call(removeAllAuthStorage);
        yield call(logoutRedirect, logoutUrl);
    }
    catch (e) {
        console.error('logoutSaga', e);
        yield put(forgeLogoutRejected());
    }
}
function* watchForgeLogout() {
    yield takeLatest(forgeProviderActions.forgeLogout, logoutSaga);
}
export default [watchForgeLogout()];
